import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getClients, getInvoices } from '../services/api';
import { showSuccessToast } from '../utils/toastConfig';
import { FiUserPlus, FiFileText, FiUsers, FiLogOut, FiDollarSign } from 'react-icons/fi';
import { MdCurrencyRupee } from "react-icons/md";
import './Dashboard.css';
import AddClient from './AddClient';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ clients: 0, invoices: 0, revenue: 0 });
  const [recentInvoices, setRecentInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
const [clients, setClients] = useState([]);
const invoicesPerPage = 5;
const [showAddClientModal, setShowAddClientModal] = useState(false);
const [showClients, setShowClients] = useState(false);
const indexOfLastInvoice = currentPage * invoicesPerPage;
const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;

const currentInvoices = recentInvoices.slice(
  indexOfFirstInvoice,
  indexOfLastInvoice
);

const totalPages = Math.ceil(recentInvoices.length / invoicesPerPage);

const goToNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
  }
};

const goToPrevPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
  }
};
const fetchDashboardData = async () => {
  try {
    const [clientsRes, invoicesRes] = await Promise.all([
      getClients(),
      getInvoices()
    ]);

    setClients(clientsRes.data);

    const totalRevenue = invoicesRes.data.reduce(
      (sum, inv) => sum + parseFloat(inv.total_amount),
      0
    );

    setStats({
      clients: clientsRes.data.length,
      invoices: invoicesRes.data.length,
      revenue: totalRevenue,
    });

    setRecentInvoices(invoicesRes.data);

  } catch (err) {
    console.error("Dashboard fetch error:", err);
  }
};

useEffect(() => {
  fetchDashboardData();
}, []);

  const handleLogout = () => {
    logout();
    showSuccessToast('Logged out successfully! 👋');
    setTimeout(() => {
      navigate('/login');
    }, 1000);
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-left">
           <img src="/veramasalogo.png" className="logo" alt="logo"/>
        </div>
        <div className="header-right">
          <span className="welcome-text">Welcome, {user?.username}</span>
          <button className="btn-logout" onClick={handleLogout}>
            <FiLogOut /> Logout
          </button>
        </div>
      </header>

      <main className="dashboard-main">
        <div className="stats-row">
          <div className="stat-card" onClick={() => setShowClients(true)}>
            <FiUsers className="stat-icon" />
            <div>
              <h3>{stats.clients}</h3>
              <p>Total Clients</p>
            </div>
          </div>
          <div className="stat-card">
            <FiFileText className="stat-icon" />
            <div>
              <h3>{stats.invoices}</h3>
              <p>Total Invoices</p>
            </div>
          </div>
          <div className="stat-card">
            <MdCurrencyRupee className="stat-icon" />
            <div>
              <h3>{stats.revenue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</h3>
              <p>Total Revenue</p>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <button className="btn-action btn-add-client" onClick={() => setShowAddClientModal(true)}>
            <FiUserPlus size={24} />
            <span>Add Client</span>
          </button>
          <button className="btn-action btn-gen-invoice" onClick={() => navigate('/generate-invoice')}>
            <FiFileText size={24} />
            <span>Generate Invoice</span>
          </button>
        </div>

        <div className="recent-section">
          <h2>Recent Invoices</h2>
          {recentInvoices.length === 0 ? (
            <p className="no-data">No invoices yet. Generate your first invoice!</p>
          ) : (
            <table className="invoice-table">
              <thead className='theader'>
                <tr>
                  <th>Invoice #</th>
                  <th>Client</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Tax Type</th>
                  <th>Total</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentInvoices.map((inv) => (
                  <tr key={inv.id}>
                    <td>{inv.invoice_number}</td>
                    <td>{inv.client_name}</td>
                    <td>{new Date(inv.invoice_date).toLocaleDateString('en-IN')}</td>
                    <td>&#8377;{parseFloat(inv.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    <td>
                      <span className={`tax-badge ${inv.tax_type === 'IGST' ? 'igst' : 'cgst'}`}>
                        {inv.tax_type === 'IGST' ? 'IGST' : 'CGST+SGST'}
                      </span>
                    </td>
                    <td>&#8377;{parseFloat(inv.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    <td>
                      <button className="btn-view" onClick={() => navigate(`/invoice/${inv.id}`)}>View</button>
                    </td>
                  </tr>
                ))}
              </tbody>
<div className="pagination">
  <button
    className="page-btn"
    onClick={goToPrevPage}
    disabled={currentPage === 1}
  >
    ← Prev
  </button>

  <div className="page-info">
    Page <strong>{currentPage}</strong> of {totalPages}
  </div>

  <button
    className="page-btn"
    onClick={goToNextPage}
    disabled={currentPage === totalPages}
  >
    Next →
  </button>
</div>
            </table>
            
          )}
        </div>
      </main>

      {showAddClientModal && (
  <div className="modal-overlay">
    <div className="modal-container">
      <AddClient
  closeModal={() => setShowAddClientModal(false)}
  refreshClients={fetchDashboardData}
/>
    </div>
  </div>
)}
{showClients && (
  <div className="modal-overlay">
    <div className="clients-modal">

      <div className="clients-header">
        <h2>All Clients</h2>
        <button onClick={() => setShowClients(false)}>✕</button>
      </div>

      <div className="clients-list">
        {clients.map((client, index) => (
          <div key={index} className="client-row">
            <h4>{client.client_name}</h4>
            <p>{client.address}</p>
          </div>
        ))}
      </div>

    </div>
  </div>
)}
    </div>
  );
};

export default Dashboard;
